import ActionWithPayload from 'moduleBase/reducers/types/ActionWithPayload';
import { NOTIFIER_HIDE, NOTIFIER_SHOW } from 'components/notifier/constants';
import { StateType } from 'components/notifier/types/StateType';
import { ShowPayloadType } from 'components/notifier/actions/types/ShowPayloadType';
import { HidePayloadType } from 'components/notifier/actions/types/HidePayloadType';

const stateDefault = {
  items: {},
};

const reducerNotifier = (
  state: StateType = stateDefault,
  action: ActionWithPayload,
): StateType => {
  switch (action.type) {
    case NOTIFIER_SHOW: {
      const payload = action.payload as ShowPayloadType;

      return {
        ...state,
        items: { ...state.items, [payload.item.id]: { ...payload.item, isVisible: true } },
      };
    }
    case NOTIFIER_HIDE: {
      const payload = action.payload as HidePayloadType;
      const items = { ...state.items };

      if (payload.force) {
        delete items[payload.id];
      } else {
        items[payload.id].isVisible = false;
      }

      return {
        ...state,
        items,
      };
    }
    default:
      return state;
  }
};

export { reducerNotifier };
